/*
 * @Author: yexiu
 * @Date: 2024-12-12 10:37:10
 * @LastEditors: yexiu
 * @LastEditTime: 2024-12-12 10:38:55
 */
import { toRefs, computed, h } from 'vue';

export default (parameter: DevelopToolShare.InitParams) => ({
    name: "imageComponent",
    props: {
        n: {
            type: String,
            required: true,
            default: ''
        },
        t: {
            type: String,
            required: false,
            default: 'png'
        },
        v: {
            type: String,
            required: false,
            default: ''
        },
        // project 项目名
        p: {
            type: String,
            required: false,
            // 默认为 'public' 公共资源
            default: parameter.componentConfig?.image?.p ?? 'public'
        }
    },
    setup(props) {
        let { n, t, v, p } = toRefs<DevelopToolShare.TImageProps>(props);
        const domian = DOMAIN.H5_IMAGE_DOMAIN;
        const copSrc = computed(() => `${domian}/${p.value}/${n.value}.${t.value}${v.value ? `?v=${v.value}` : ''}`);

        return () => h('img', { src: copSrc.value });
    }
});